import { Control, FieldErrors } from "react-hook-form";
import { SelectField } from "../../../../../atoms/FormFields";

const Property = ({
  control,
  errors,
}: {
  control: Control;
  errors: FieldErrors;
}) => {
  return (
    <SelectField
      fieldName="crewYardName"
      label="Property name"
      control={control}
      selectOption={[
        { label: "North bend Business Park", value: "main_branch" },
        { label: "Sapphire Springs Villas", value: "south_east" },
      ]}
      iProps={{
        placeholder: "Select property",
      }}
      isRequired
      rules={{
        required: "Property name is required.",
      }}
      validate={errors.crewYardName && "error"}
      validMessage={
        typeof errors.crewYardName?.message === "string"
          ? errors.crewYardName.message
          : undefined
      }
      tooltipTitle="Crew yard name"
    />
  );
};

export default Property;
